import {RetryOptions} from 'nice-grpc-client-middleware-retry';
import {Client} from 'nice-grpc-web';
import {createContext} from 'react';
import {JackPokerExchequerDefinition} from '../proto/deeplay/jackpoker_exchequer/v1/jackpoker_exchequer';

export const exchequerClientContext = createContext<Client<
  typeof JackPokerExchequerDefinition,
  RetryOptions
> | null>(null);
